/**
 * Special Order Enquiry - "Enquire About This Size" for sold-out sizes.
 *
 * Replaces the previous Notify Me / Klaviyo back-in-stock button. Shows an
 * enquiry button whenever the selected size/variant is sold out. The modal
 * itself (including the real Shopify contact form + CAPTCHA protection) is
 * rendered server-side in theme.liquid - this file only opens/closes it,
 * fills in product context, and composes the message before it submits.
 */
(function () {
  'use strict';

  function getScope(form) {
    // The variant JSON blob and the size/variant radio buttons are rendered
    // as siblings of the <form>, not inside it - both live inside the
    // shared ".product-single__meta" wrapper for the product.
    return form.closest('.product-single__meta') || form.parentElement || form;
  }

  function getVariantsData(form) {
    var el = getScope(form).querySelector('[data-variant-json]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptionValues(form) {
    var values = [];
    var fieldsets = getScope(form).querySelectorAll('.variant-input-wrap');
    fieldsets.forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) {
        values.push(checked.value);
      }
    });
    return values;
  }

  function findMatchingVariant(variants, selectedValues) {
    if (!selectedValues.length) return null;
    return variants.filter(function (v) {
      return [v.option1, v.option2, v.option3].every(function (opt, i) {
        return selectedValues[i] === undefined || opt === selectedValues[i];
      });
    })[0];
  }

  function syncButtons(form) {
    var variants = getVariantsData(form);
    if (!variants.length) return;

    var selectedValues = getSelectedOptionValues(form);
    var variant = findMatchingVariant(variants, selectedValues) || variants[0];
    if (!variant) return;

    var addBtn = form.querySelector('[data-add-to-cart]');
    var wrap = form.querySelector('[data-enquire-special-order-wrap]');
    var enquireBtn = form.querySelector('[data-enquire-special-order]');
    if (!addBtn || !wrap || !enquireBtn) return;

    enquireBtn.setAttribute('data-variant-id', variant.id);
    enquireBtn.setAttribute('data-variant-title', variant.title);

    if (variant.available) {
      addBtn.style.display = '';
      addBtn.removeAttribute('disabled');
      wrap.style.display = 'none';
    } else {
      addBtn.style.display = 'none';
      addBtn.setAttribute('disabled', 'disabled');
      wrap.style.display = '';
    }
  }

  function initForm(form) {
    if (form.dataset.soeBound) return;
    form.dataset.soeBound = 'true';
    syncButtons(form);

    // The size/variant radio inputs live outside the <form> (as siblings
    // within the shared product wrapper), so listen on that wrapper -
    // a 'change' on the radios would never bubble up into the form itself.
    var scope = getScope(form);
    scope.addEventListener('change', function (e) {
      if (
        e.target.matches('input[type="radio"][data-variant-input]') ||
        e.target.matches('select[data-product-select]')
      ) {
        setTimeout(function () {
          syncButtons(form);
        }, 0);
      }
    });
  }

  function initAllForms(root) {
    (root || document).querySelectorAll('.product-single__form').forEach(initForm);
  }

  /* ---------------- Modal ---------------- */

  function getModal() {
    return document.getElementById('soeModal');
  }

  function bindModal(wrap) {
    if (!wrap || wrap.dataset.soeModalBound) return;
    wrap.dataset.soeModalBound = 'true';

    wrap.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-soe-close')) {
        closeModal();
      }
    });

    var form = document.getElementById('soeContactForm');
    if (!form) return;

    // Intentionally no preventDefault() here - the browser proceeds with a
    // real submission (required for Shopify's CAPTCHA protection to run
    // and complete, the same way it does on the theme's own contact form).
    // This handler just composes the message and shows a "Sending..."
    // state in the moment before the page navigates away.
    form.addEventListener('submit', function () {
      var submitBtn = wrap.querySelector('[data-soe-submit]');
      var errorEl = wrap.querySelector('[data-soe-error]');
      var productTitle = wrap.getAttribute('data-product-title') || '';
      var productUrl = wrap.getAttribute('data-product-url') || '';
      var variantTitle = wrap.getAttribute('data-variant-title') || '';
      var phone = wrap.querySelector('[data-soe-phone]').value.trim();
      var note = wrap.querySelector('[data-soe-note]').value.trim();

      var bodyLines = [
        'Special order enquiry',
        'Product: ' + productTitle,
        'Size requested: ' + variantTitle,
        'Product link: ' + productUrl
      ];
      if (phone) bodyLines.push('Phone: ' + phone);
      if (note) bodyLines.push('', 'Note from customer:', note);
      wrap.querySelector('[data-soe-body]').value = bodyLines.join('\n');

      try {
        sessionStorage.setItem('soeLastEnquiry', JSON.stringify({
          productTitle: productTitle,
          variantTitle: variantTitle
        }));
      } catch (e) {
        // sessionStorage unavailable (e.g. private browsing) - the success
        // message will just fall back to generic wording after reload.
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      errorEl.textContent = '';

      // If the page is still here 10s after a real submit, something
      // stopped it before it could navigate away (this callback never runs
      // if the page actually leaves, since navigation destroys this JS
      // context) - surface that instead of hanging silently forever.
      setTimeout(function () {
        errorEl.textContent = 'This is taking longer than expected - please try again in a moment, or contact us directly if it keeps happening.';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send Enquiry';
      }, 10000);
    });
  }

  function openModal(btn) {
    var wrap = getModal();
    if (!wrap) return;
    bindModal(wrap);

    var productTitle = btn.getAttribute('data-product-title') || '';
    var productImage = btn.getAttribute('data-product-image') || '';
    var productUrl = btn.getAttribute('data-product-url') || '';
    var variantTitle = btn.getAttribute('data-variant-title') || '';

    wrap.setAttribute('data-product-title', productTitle);
    wrap.setAttribute('data-product-url', productUrl);
    wrap.setAttribute('data-variant-title', variantTitle);

    wrap.querySelector('[data-soe-chip-image]').src = productImage;
    wrap.querySelector('[data-soe-chip-title]').textContent = productTitle;
    wrap.querySelector('[data-soe-chip-size]').textContent = variantTitle;

    wrap.querySelector('[data-soe-form-view]').style.display = '';
    wrap.querySelector('[data-soe-success-view]').style.display = 'none';
    wrap.querySelector('[data-soe-error]').textContent = '';

    var form = document.getElementById('soeContactForm');
    if (form) form.reset();

    wrap.classList.add('is-open');
    document.body.classList.add('soe-modal-open');
  }

  function closeModal() {
    var wrap = getModal();
    if (wrap) {
      wrap.classList.remove('is-open');
      document.body.classList.remove('soe-modal-open');
    }
  }

  // After a real submission, Shopify redirects back to this page. If that
  // submission succeeded, theme.liquid sets window.SOE_POSTED_SUCCESSFULLY
  // - open the modal straight to the success view so it still feels like a
  // seamless in-page flow rather than a plain page reload.
  function checkPostedSuccess() {
    if (!window.SOE_POSTED_SUCCESSFULLY) return;

    var wrap = getModal();
    if (!wrap) return;
    bindModal(wrap);

    var stored = null;
    try {
      var raw = sessionStorage.getItem('soeLastEnquiry');
      if (raw) stored = JSON.parse(raw);
      sessionStorage.removeItem('soeLastEnquiry');
    } catch (e) {}

    var variantTitle = (stored && stored.variantTitle) || 'requested size';
    var productTitle = (stored && stored.productTitle) || 'this item';

    showSuccess(wrap, variantTitle, productTitle);
    wrap.classList.add('is-open');
    document.body.classList.add('soe-modal-open');
  }

  function showSuccess(wrap, variantTitle, productTitle) {
    wrap.querySelector('[data-soe-form-view]').style.display = 'none';
    var successView = wrap.querySelector('[data-soe-success-view]');
    successView.style.display = '';
    wrap.querySelector('[data-soe-success-text]').textContent =
      'Thanks! We’ve received your enquiry and will check availability of the size you require, and be in touch soon.';

    var submitBtn = wrap.querySelector('[data-soe-submit]');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send Enquiry';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-enquire-special-order]');
    if (!btn) return;
    e.preventDefault();
    openModal(btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function init() {
    initAllForms(document);
    bindModal(getModal());
    checkPostedSuccess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.product-single__form')) {
          initForm(node);
        } else if (node.querySelectorAll) {
          initAllForms(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
